import React from "react"
import Flex from "@irati/ui/src/Flex"
import {ButtonLink, ButtonRouterLink} from "@irati/ui/src/Link"
import Spacing from "@irati/ui/src/Spacing"
import {Body, H2} from "@irati/ui/src/Typography"
import FormattedMessage, {useIntl} from "@irati/utils/lang"
import isContentKey from "@irati/utils/lang/helpers/isContentKey"
import adminTracking, {CustomRewardTypes} from "@irati-tracking/admin/admin"
import {SETTINGS_CUSTOM_REWARDS_CREATE, SETTINGS_CUSTOM_REWARDS_TRANSACTIONS} from "../../../routes/routeConfig"
import CustomRewardsList from "./CustomRewardsList"
const CustomRewards = () => {
  const intl = useIntl()
  const learnMoreLink = intl.formatMessage({id: "admin.customRewards.home.learnMore"})
  return (
    <Flex direction="column" gap={1}>
      <H2>
        <FormattedMessage id="admin.customRewards.home.heading" />
      </H2>
      <Body small>
        <FormattedMessage id="admin.customRewards.home.body" />
      </Body>
      <Flex marginTop={1} gap={2}>
        <ButtonRouterLink
          primary
          to={SETTINGS_CUSTOM_REWARDS_CREATE}
          onClick={() => adminTracking.sendCustomRewardEvent(CustomRewardTypes.ADD_CUSTOM_REWARD)}>
          <FormattedMessage id="admin.customRewards.home.cta" />
        </ButtonRouterLink>
        {!isContentKey(learnMoreLink) && !!learnMoreLink && (
          <ButtonLink href={learnMoreLink} target="_blank">
            <FormattedMessage id="platform.cta.learnMore" />
          </ButtonLink>
        )}
        <ButtonRouterLink
          to={SETTINGS_CUSTOM_REWARDS_TRANSACTIONS}
          onClick={() => adminTracking.sendCustomRewardEvent(CustomRewardTypes.VIEW_TRANSACTIONS)}>
          <FormattedMessage id="admin.customRewards.btn.viewTransactions" />
        </ButtonRouterLink>
      </Flex>
      <Spacing marginTop={4}>
        <CustomRewardsList />
      </Spacing>
    </Flex>
  )
}

export default CustomRewards
